//image configuration
export const imageConfig = {
    quality: 0.2,
    maxWidth: 800,
    maxHeight: 600,
    autoRotate: true
  };
  